import { createSelector } from 'reselect';
import { prop } from 'ramda';

export const selectLegalDomain = prop('legal');

export const selectTermsAndConditionsContent = createSelector(
  selectLegalDomain,
  prop('termsAndConditions')
);

export const selectPrivacyPolicyContent = createSelector(
  selectLegalDomain,
  prop('privacyPolicy')
);

export const selectCookiesPolicyContent = createSelector(
  selectLegalDomain,
  prop('cookiesPolicy')
);
